module.exports = __webpack_public_path__ + "img/mruAdminitration.c629bc2f.jpg";